// extracted by mini-css-extract-plugin
export var container = "_m7-0";
export var dotAnimation = "_m7-2";
export var dotsLoading = "_m7-1";